<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-icon-line-set2`]" width="1em" height="1em" v-bind="$attrs"><path d="M11.835 10.116C12.4563 10.116 12.96 10.6196 12.96 11.241V12.1188H15.6605C16.0736 12.1188 16.4086 12.4538 16.4086 12.8669C16.4085 13.2801 16.0736 13.6151 15.6605 13.6151H12.96V14.494C12.9596 15.1149 12.4561 15.619 11.835 15.619C11.214 15.619 10.7105 15.1149 10.71 14.494V11.241C10.71 10.6196 11.2137 10.116 11.835 10.116ZM9.08954 12.1188C9.50272 12.1188 9.83771 12.4538 9.83771 12.8669C9.83762 13.28 9.50266 13.6151 9.08954 13.6151H2.33954C1.92663 13.6149 1.59146 13.2799 1.59137 12.8669C1.59137 12.4539 1.92657 12.119 2.33954 12.1188H9.08954ZM6.16827 2.375C6.78959 2.375 7.29327 2.87868 7.29327 3.5V6.75305C7.29294 7.37409 6.78939 7.87805 6.16827 7.87805C5.54716 7.87805 5.04361 7.37409 5.04327 6.75305V5.87415H2.33954C1.92658 5.87389 1.59137 5.53899 1.59137 5.12598C1.59141 4.71299 1.9266 4.37807 2.33954 4.37781H5.04327V3.5C5.04327 2.87868 5.54695 2.375 6.16827 2.375ZM15.6605 4.37781C16.0736 4.37781 16.4086 4.71283 16.4086 5.12598C16.4086 5.53915 16.0736 5.87415 15.6605 5.87415H8.91046C8.49743 5.87397 8.16229 5.53905 8.16229 5.12598C8.16233 4.71294 8.49745 4.37798 8.91046 4.37781H15.6605Z"/></svg>
</template>
<script>

export default {
  name: 'IconIconLineSet2',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
